


import Body from "./components/Body";
import Header from "./components/Header";





function App() {
  
  return (
    <div className="">
      <Header/>
      <Body/>
    </div>
  );
}

export default App;
